import { finish, error } from 'src/modules/reports/actions/run';
import api from 'src/api';
import { apiCommon } from 'src/api/ApiCommon';

export function request(dispatch, { reportType, accountId, params }) {
    if (reportType === 'isonis') {
        return apiCommon.putIsonis.run({
            data: {
                from: params.startDate,
                to: params.endDate
            }
        }).then(
            () => dispatch(finish()),
            ({ errors }) => dispatch(error(errors))
        );
    }

    let url;

    if (reportType === 'statements') {
        url = `/reports/${reportType}/${accountId}`;
    } else {
        url = `/reports/${reportType}`;
    }

    api.post(url, params).then(
        () => dispatch(finish()),
        ({ errors }) => dispatch(error(errors))
    );
}
